import styled from 'styled-components';

export const Logo = styled.img`
  width: 150px;
  display: block;
  margin: 40px auto 70px;
`;

export const Thumbnail = styled.img`
  width: 40px;
  display: block;
  margin: 40px auto 56px;
`;
